export default "__VITE_ASSET__Dn3rY40___"